import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import FormatMoney from "go-core/components/Formatters/FormatMoney";
import { hasPermission } from "go-security/services/organizations/selectors";
import { EmployeeApi } from "../../../../../../../../../../services/Api/Organization/types";

interface Props {
	employee: EmployeeApi;
}

const EmployeeHeaderSubtitle = ({ employee }: Props) => {
	const hasVenueEmployeeHourlyRateAccess = useSelector(hasPermission("VENUE_EMPLOYEE_HOURLY_RATE_ACCESS"));
	const { t } = useTranslation();

	return (
		<ul>
			<li>
				{employee?.venue_role?.name && <div className="me-3 d-inline-block">{employee?.venue_role?.name}</div>}
				{employee.workplace ? (
					<div className="me-3 d-inline-block">
						{t("modules.employee.field.workplace.title")} {employee.workplace?.name}{" "}
						{employee.hourly_rate?.amount ? `${FormatMoney(employee.hourly_rate)}/h` : null}
					</div>
				) : (
					<>
						{(employee.hourly_rate?.amount || employee.hourly_rate?.amount === 0) && (
							<div className="me-3 d-inline-block">{`${FormatMoney(employee.hourly_rate)}/h`}</div>
						)}
					</>
				)}
				{hasVenueEmployeeHourlyRateAccess &&
					employee.workplaces.map((emp, index) => {
						return (
							<div key={index} className="me-3 d-inline-block">
								{t("modules.employee.field.workplace.title")} {emp.workplace.name} (
								{FormatMoney(emp.hourly_rate)}/h)
							</div>
						);
					})}
			</li>
		</ul>
	);
};

export default EmployeeHeaderSubtitle;
